import React from 'react'
import { Helmet } from 'react-helmet'
import LiveTemplateDefault from 'src/components/template/live'
import { networkLogos } from 'src/constants'
import { createVideoStructuredData } from 'src/modules/utils/videoStructuredData'

export default (props) => {
  // VideoObject structured data
  const videoStructuredData = createVideoStructuredData({
    networkName: 'Nickelodeon',
    callsign: 'NIKHD',
    logoUrl: networkLogos.nickelodeon.logoUrl,
    slug: 'nickelodeon',
  })

  return (
    <>
      <Helmet>
        <script type="application/ld+json">{JSON.stringify(videoStructuredData)}</script>
      </Helmet>
      <LiveTemplateDefault
        location={props.location}
        lang="en"
        market="us"
        callsign="NIKHD"
        title="Watch Nickelodeon live online with Fubo"
        networkName="Nickelodeon"
      />
    </>
  )
}
